/**
 * Apollo Cache Model Reducers
 */
import { DataProxy } from 'apollo-cache';
import produce, { Draft } from 'immer';
import { remove } from 'lodash';

import { ContentFragment, ContentFragmentDoc, UserProfileFragment } from 'api';

interface IReducer {
  name: keyof IReducers;
  cache: DataProxy;
  id: ContentFragment['content_id'];
  data?: { profile?: UserProfileFragment };
}

interface IReducers {
  createReaction: (
    fragment: ContentFragment,
    data: { profile?: UserProfileFragment },
  ) => ContentFragment;
  deleteReaction: (
    fragment: ContentFragment,
    data: { profile?: UserProfileFragment },
  ) => ContentFragment;
  newComment: (
    fragment: ContentFragment,
    data: { profile?: UserProfileFragment },
  ) => ContentFragment;
}

const reducers: IReducers = {
  createReaction: produce((fragment: Draft<ContentFragment>, data) => {
    fragment.reaction_count++;
    fragment.reacted_by.unshift({
      ...data.profile,
      __typename: 'MinimalUserProfile',
    });
    return fragment;
  }),
  deleteReaction: produce((fragment: Draft<ContentFragment>, data) => {
    fragment.reaction_count--;
    remove(fragment.reacted_by, item => {
      return item.id === data.profile.id;
    });
    return fragment;
  }),
  newComment: produce((fragment: Draft<ContentFragment>) => {
    fragment.comment_count++;
    return fragment;
  }),
};

export default (options: IReducer) => {
  const { name, cache, id, data } = options;

  const fragment: ContentFragment = cache.readFragment({
    id,
    fragment: ContentFragmentDoc,
    fragmentName: 'Content',
  });

  if (!fragment) {
    return;
  }

  cache.writeFragment({
    id,
    fragment: ContentFragmentDoc,
    fragmentName: 'Content',
    data: reducers[name](fragment, data),
  });
};
